import React from "react"
import CategoryLink from "../components/category-link"
import HighlightedArticle from "../components/highlighted-article"
import Layout from "../components/layout/layout"
import NormalArticle from "../components/normal-article"
import SEO from "../components/seo"
import { Articles } from "../data/articles"

const IndexPage = () => (
  <Layout>
    <SEO
      title="Home"
      keywords={[`people management`, `software development`]}
    />
    <section id="section">
      {Articles.getHighlighted().map(article => (
        <HighlightedArticle article={article} key={article.link} />
      ))}

      {Articles.getOneByCategory().map(ac => (
        <div className="categ" key={ac.category}>
          <h2 className="categ-title">
            <CategoryLink cat={ac.category} />
          </h2>
          <NormalArticle article={ac.article} key={ac.article.link} />
          <div className="categ-list">
            <div className="article-more categ-article-more">
              <CategoryLink
                cat={ac.category}
                text={`...all in ${ac.category}`}
              />
            </div>
          </div>
        </div>
      ))}
    </section>
  </Layout>
)

export default IndexPage
